export const FlareEditorElementAttributeWhitelist: Dictionary<RegExp> = {
  'accept': /.*/,
  'accept-charset': /.*/,
  'accesskey': /.*/,
  'action': /.*/,
  'align': /.*/,
  'allow': /.*/,
  'alpha': /.*/,
  'alt': /.*/,
  'as': /.*/,
  'async': /.*/,
  'autocapitalize': /.*/,
  'autocomplete': /.*/,
  // Exclude 'autoplay' to prevent auto playback of audio and video in the editor
  // 'autoplay': /.*/,
  'background': /.*/,
  'bgcolor': /.*/,
  'border': /.*/,
  'capture': /.*/,
  'charset': /.*/,
  'checked': /.*/,
  'cite': /.*/,
  'class': /.*/,
  'color': /.*/,
  'colorspace': /.*/,
  'cols': /.*/,
  'colspan': /.*/,
  'compact': /.*/,
  'content': /.*/,
  // Exclude 'contenteditable' because it could prevent this content from being edited in the editor
  // 'contenteditable': /.*/,
  'controls': /.*/,
  'coords': /.*/,
  // Only allow 'annonymous' value for 'crossorigin' to prevent credentials from being sent to third parties with 'use-credentials'
  'crossorigin': /^anonymous$/,
  'csp': /.*/,
  // Exclude 'data' to prevent malicious content from being loaded in the editor
  // 'data': /.*/,
  'datetime': /.*/,
  'decoding': /.*/,
  'default': /.*/,
  'defer': /.*/,
  'dir': /.*/,
  'dirname': /.*/,
  'disabled': /.*/,
  'download': /.*/,
  // Exclude 'draggable' because it could interfere with the editor's drag and drop functionality
  // 'draggable': /.*/,
  'elementtiming': /.*/,
  'enctype': /.*/,
  'enterkeyhint': /.*/,
  'fetchpriority': /.*/,
  // Exclude 'for' because it prevents the user from clicking on labels in the editor
  // 'for': /.*/,
  'form': /.*/,
  'formaction': /.*/,
  'formenctype': /.*/,
  'formmethod': /.*/,
  'formnovalidate': /.*/,
  'formtarget': /.*/,
  'glossTerm': /.*/, // Non-namespaced MadCap attribute
  'headers': /.*/,
  'height': /.*/,
  // Exclude 'hidden' because it prevents this content from being seen and edited in the editor
  // 'hidden': /.*/,
  'high': /.*/,
  'href': /.*/,
  'hreflang': /.*/,
  'http-equiv': /.*/,
  'id': /.*/,
  'integrity': /.*/,
  'inputmode': /.*/,
  'ismap': /.*/,
  'itemprop': /.*/,
  'kind': /.*/,
  'label': /.*/,
  'lang': /.*/,
  'language': /.*/,
  'loading': /.*/,
  'list': /.*/,
  'loop': /.*/,
  'low': /.*/,
  'max': /.*/,
  'maxlength': /.*/,
  'media': /.*/,
  'method': /.*/,
  'minlength': /.*/,
  'min': /.*/,
  'multiple': /.*/,
  'muted': /.*/,
  'name': /.*/,
  'novalidate': /.*/,
  'open': /.*/,
  'optimum': /.*/,
  'pattern': /.*/,
  'ping': /.*/,
  'placeholder': /.*/,
  'playsinline': /.*/,
  'poster': /.*/,
  'preload': /.*/,
  'readonly': /.*/,
  // Exclude 'referrerpolicy' to prevent potential privacy leaks from referrer information being sent to third parties
  // 'referrerpolicy': /.*/,
  'rel': /.*/,
  'required': /.*/,
  'reversed': /.*/,
  'role': /.*/,
  'rows': /.*/,
  'rowspan': /.*/,
  'sandbox': /.*/,
  'scope': /.*/,
  'selected': /.*/,
  'shape': /.*/,
  'size': /.*/,
  'sizes': /.*/,
  'slot': /.*/,
  'span': /.*/,
  'spellcheck': /.*/,
  'src': /.*/,
  'srcdoc': /.*/,
  'srclang': /.*/,
  'srcset': /.*/,
  'start': /.*/,
  'step': /.*/,
  'style': /.*/,
  'summary': /.*/,
  // Exclude 'tabindex' because it could interfere with the editor's keyboard navigation
  // 'tabindex': /.*/,
  'target': /.*/,
  'targets': /.*/, // Non-namespaced MadCap attribute
  'term': /.*/, // Non-namespaced MadCap attribute
  'title': /.*/,
  'translate': /.*/,
  'type': /.*/,
  'usemap': /.*/,
  'value': /.*/,
  'width': /.*/,
  'wrap': /.*/,
  'xml:lang': /.*/,
  'xml:space': /.*/,
  'xmlns:MadCap': /.*/
};
